import { connect } from 'react-redux';
import UtilityInputs from './UtilityInputs';

import {
    setUtilityAnnualInflation,
    setUtilityEnergyValue,
    setUtilityProvider,
} from '../../common/utility/actions';

import { toggleAnnualMonth } from '../../common/settings/actions';
import { selectTotalkWh, selectTotalFixed } from '../../common/utility/selectors';


import { setUtilityInputsIsVisible } from './actions';

const mapStateToProps = state => ({
    annualInflation: state.utility.annualInflation,
    energyValue: state.utility.energyValue,
    isLocked: state.isLockedUI.isLocked,
    isVisible: state.utilityInputsUI.isVisible,
    provider: state.utility.provider,
    annualMonth: state.settings.annualMonth,
    projectState: state.projectaddressUI.projectState,
    totalkWhs: selectTotalkWh(state),
    totalFixed: selectTotalFixed(state),
    setUtilityAnnualInflation,
    setUtilityEnergyValue,
    setUtilityInputsIsVisible,
    setUtilityProvider,
    toggleAnnualMonth,
});

const combinedActions = {
    setUtilityEnergyValue,
    setUtilityProvider,
    setUtilityInputsIsVisible,
    setUtilityAnnualInflation,
    toggleAnnualMonth,
};

export default connect(mapStateToProps, combinedActions)(UtilityInputs);



// WEBPACK FOOTER //
// ./src/containers/Inputs/UtilityInputs/index.js